import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncNewsEntryCreate = lazy(() => import('~/containers/NewsEntryCreate'));

export default [
  <Route path="/news-entries/create">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncNewsEntryCreate />
    </Suspense>
  </Route>,
];
